import styled from 'styled-components';
import { spacingMap } from '../../theming';
import { readHDSTheme } from '../../utils';

// Using a template literal type would make this code cleaner, but isn't supported in the HubSpot stack as of October 2023
import { jsx as _jsx } from "react/jsx-runtime";
// Sets the component to render a `div` element with vertical spacing
const StyledBlockSpacer = styled.div.withConfig({
  displayName: "HDSSpacer__StyledBlockSpacer",
  componentId: "sc-19c4yv5-0"
})(["box-sizing:border-box;height:", ";"], ({
  theme,
  $space
}) => readHDSTheme(theme).UNSTABLE_HDS[spacingMap[$space]]);

// Sets the component to render a `span` element with horizontal spacing
const StyledInlineBlockSpacer = styled.span.withConfig({
  displayName: "HDSSpacer__StyledInlineBlockSpacer",
  componentId: "sc-19c4yv5-1"
})(["box-sizing:border-box;width:", ";display:inline-block;"], ({
  theme,
  $space
}) => readHDSTheme(theme).UNSTABLE_HDS[spacingMap[$space]]);
export const HDSSpacer = ({
  display = 'block',
  space = '400'
}) => {
  const SpacerComponent = display === 'block' ? StyledBlockSpacer : StyledInlineBlockSpacer;
  return /*#__PURE__*/_jsx(SpacerComponent, {
    $display: display,
    $space: space
  });
};